import React from 'react'
import 'brace/mode/javascript'
import 'brace/theme/github'
import { Alert, Row, FormControl, Glyphicon, Button } from 'react-bootstrap'

export default class Input extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      alert: {
        level: null,
        message: null
      },
      editingContext: '',
      openButton: false,
      descriptionOfGist: ''
    }
    this.handleChangeDesc = this.handleChangeDesc.bind(this)
  }

  handleShowButton () {
    this.setState({
      openButton: !this.state.openButton
    })
  }

  componentDidUpdate (prevProps, prevState) {
    if ((prevProps.mapped !== this.props.mapped || prevProps.vocabularyType !== this.props.vocabularyType) &&
      Object.keys(this.props.inputKeys).length > 0
      && Object.keys(this.props.selectedContext).length > 0) {
      const header = {}
      const mapped = {}

      Object.keys(this.props.inputKeys).forEach(key => {
        // @id @typeにチェックがあったらheader部分に追加
        if (this.props.vocabularyType[key]) {
          header[key] = '@'.concat(this.props.vocabularyType[key])
        } else {
          if (this.props.mapped && this.props.mapped.hasOwnProperty(key) && this.props.mapped[key].property) {
            mapped[key] = {'@id': this.props.mapped[key].property}
            if (this.props.mapped[key].type) {
              mapped[key] = Object.assign(mapped[key], {'@type': this.props.mapped[key].type})
            }
          } else {
            mapped[key] = {'@id': 'json2ld:' + key}
          }
        }
      })
      const context = Object.assign(header, {
        '@vocab': 'http://json2ld.mapper.tokyo/ns/',
        'json2ld': 'http://json2ld.mapper.tokyo/ns/'
      }, mapped)
      const newContext = {
        '@context': [this.props.selectedContext.uri,
          context
        ]
      }
      this.editContext(newContext)
    }
    if (this.state.editingContext !== prevState.editingContext) {
      this.checkParseToJson(this.state.editingContext)
    }
    return true
  }

  // Context編集エリアを変更
  editContext (newValue) {
    let json = ''
    if (typeof (newValue) === 'string') {
      if (newValue.indexOf('\t') > 0) {
        json = newValue
      } else {
        json = JSON.stringify(JSON.parse(newValue), null, '\t')
      }
    } else {
      json = JSON.stringify(newValue, null, '\t')
    }
    this.setState({editingContext: json})
  }

  /**
   * JSON形式をチェックし、エラーがあったらalertをセット
   * @param context
   * @returns {{level: null, message: null}}
   */
  checkParseToJson (context) {
    let json = context
    let alert = {level: null, message: null}
    if (json === '') {
      json = JSON.stringify({'@context': ''}, null, '\t')
    }
    try {
      this.props.setParsedContext(JSON.parse(json))
    } catch (error) {
      alert = {
        level: 'warning',
        message: `"${error.message}". Please edit or re-upload.`,
      }
    }

    this.setState({alert: alert})
  }

  handleChangeDesc (e) {
    this.setState({descriptionOfGist: e.target.value})
  }

  saveContextToGist (content, props) {
    if (!this.state.descriptionOfGist) {
      this.setState({alert: {level: 'warning', message: 'Descriptionを入力してください',}})
      return
    } else {
      this.setState({alert: {level: null, message: null}})
    }

    const filename = 'json2ld-context.json'
    const auth = 'token ' + props.accessToken

    fetch('https://api.github.com/gists', {
      method: 'POST'
      , mode: 'cors'
      , headers: {
        'Authorization': auth
        , 'Accept': 'application/json'
        , 'Content-Type': 'application/json'
      }
      , body: JSON.stringify({
        public: true
        , description: this.state.descriptionOfGist
        , files: {
          [filename]: {content: content}
        }
      })
    }).then(result => {
      if (result.ok) {
        this.setState({alert: {level: 'success', message: '保存しました'}, descriptionOfGist: ''})
        return result.json()
      } else {
        throw new Error('Network Error')
      }
    }).then(result => {
      Object.keys(result.files).forEach((key, i) => {
        if (i === 0) {
          console.log(result.files[key])
          let context = JSON.stringify({'@context': result.files[key].raw_url}, null, '\t')
          this.setState({editingContext: context})
          this.props.updateContextListFromGist(this.props, result.description, result.files[key].raw_url)
        }
      })
    }).catch(error => (console.log(error)))
  }

  render () {
    const jsonLd = Object.keys(this.props.contents).length > 0 ?
      JSON.stringify(Object.assign({}, {'@graph': this.props.contents}, this.props.parsedContext), null, '\t') : '{}'
    const context = JSON.stringify(this.props.parsedContext, null, '\t')
    const link = 'https://json-ld.org/playground/#startTab=tab-expanded&json-ld='.concat(jsonLd)

    return (
      <React.Fragment>
        <Row className="flow_border">
          <h3 className="row_heading">Preview JSON-LD</h3>
          <FormControl componentClass="textarea" placeholder="textarea"
                       id="previewJSONLD"
                       readOnly
                       value={jsonLd}
                       style={{height: this.props.user.uid ? '37vh' : '50vh', marginBottom: '20px'}}
          />
          {Object.keys(this.props.inputKeys).length > 0 ?
            <div className="select_button__wrapper">
              <div className={this.state.openButton ? 'select_button active' : 'select_button'}　id="downloadJSONLD">
                <div className="select_button__arrow" onClick={() => this.handleShowButton()}/>
                <Button className="green_button" onClick={() => this.props.downloadJsonLd(this.props, jsonLd)}>
                  <Glyphicon glyph="download-alt"/> Download JSON-LD
                </Button>
                <Button className="green_button" onClick={() => this.props.downloadContext(this.props, context)}　id="downloadContext">
                  <Glyphicon glyph="download-alt"/> Download Context
                </Button>
              </div>
              <Button className="green_button tar" variant="link" href={link} target="_blank"　id="openJSONLDPlayground">
                <Glyphicon glyph="new-window"/>Open JSON-LD Playground
              </Button>
            </div>
            : null}
        </Row>
        {this.props.user.uid ?
          <Row className="flow_border">
            <h3 className="row_heading">Save context to Gist</h3>
            <div className="input_text__wrapper">
              <p className="input_text__heading">Description</p>
              <input type="text" className="input_text__input" value={this.state.descriptionOfGist}
                     onChange={e => this.handleChangeDesc(e)}/>
              <input type="button" value="Save" className="input_text__button"
                     onClick={() => this.saveContextToGist(this.state.editingContext, this.props)}/>
              {this.state.alert.message ? <Alert bsStyle={this.state.alert.level}>
                  {this.state.alert.message}
                </Alert>
                : null
              }
            </div>
          </Row>
          : null}
      </React.Fragment>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Preview.js